import { CarbucksVehicleEventTypeDescriptions, type CarbucksVehicleEventType } from './CarbucksVehicleEventType';
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import type { IHistoryItem, IHistoryItemDto } from "./IHistoryItem";

export class HistoryItem implements IHistoryItem
{

    vehicleId: string;
    title?: string;
    type: CarbucksVehicleEventType;
    description: string;
    utcEventDate: Dayjs;

    constructor( model: IHistoryItemDto )
    {
        this.vehicleId = model.vehicleId;
        this.type = model.type;
        this.title = CarbucksVehicleEventTypeDescriptions.get( model.type );
        this.description = model.description;
        this.utcEventDate = dayjs( model.utcEventDate );
    }

}
